module.exports = "/_next/static/chunks/fonts/HindMadurai-Normal-74d538d70c81637b610eca13fffaab47.woff";